export const APIError = {
  ConnectFail: -1,
  InvalidParams: -2,
};
